import { Item } from '@filament/common-react';
import { FlexBox } from "@filament/react/layout";
import { TabContext, Tabs } from "@filament/react/tabs";
import { Text } from "@filament/react/text";
import { Key } from "@filament/react/types";
import { useSession } from '@/entities/session';

export const OrganizationSwitcher = () => {
    const { userOrganizations, currentOrganization, switchOrganization } = useSession();
    const selectedOrgKey = currentOrganization.organizationId ?? ''

    const handleSelectionChange = (organizationId: Key | null) => {
        if (!organizationId) return;

        switchOrganization(organizationId as string)
    };

    return (
        <FlexBox flexDirection="column" gap={4}>
            <Text variant="body-s">Organizations</Text>
            <div style={{ padding: '0 10px' }}>
                <TabContext
                    selectedKey={selectedOrgKey}
                    onSelectionChange={handleSelectionChange} >
                    <Tabs placement="left" isFullWidth>
                        {userOrganizations.map(o =>
                            <Item
                                key={o.organizationId}
                                textValue={o.name}>
                                {o.name}
                            </Item>
                        )}
                    </Tabs>
                </TabContext>
            </div>
        </FlexBox>
    )
}